import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var TikTokColor = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.506 38.86c-9.09-7.89-3.211-25.454 10.766-23.244v1.627c-11.804-.55-17 13.53-10.766 21.616ZM33 8.39c1.437 1.147 3.417 1.994 6.147 2.155v1.594c-3.02-.558-4.935-2.06-6.147-3.75ZM29.21 0c-.002.588.075 1.22.171 1.797h-5.572v27.742c0 1.279-.132 2.417-.394 3.416-2.269 5.002-8.693 4.348-10.468.916 2.643 1.655 6.989 1.215 8.772-2.713.26-.997.392-2.138.392-3.416V0h7.1Z",
    svgColor: "#00F7EF"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.909 1.797v.036c.002.642.19 9.93 9.937 10.51 0 8.64.005 0 .005 7.176-.732.043-6.416-.368-9.953-3.522l-.01 13.97c.087 6.326-3.435 12.53-10.028 13.78-1.847.35-3.51.39-6.302-.22-16.084-4.812-10.74-28.667 5.41-26.114 0 7.702.005-.002.005 7.702-6.672-.982-8.904 4.568-7.13 8.542 1.613 3.618 8.256 4.403 10.573-.702.262-.999.393-2.138.393-3.416V1.797h7.1Z",
    svgColor: "#000"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.272 17.243c.55.024 1.117.078 1.696.17 0 7.701.005-.002.005 7.701-6.672-.981-8.904 4.569-7.13 8.542.032.073.067.145.104.215-.793-.497-1.431-1.178-1.803-2.012-1.77-3.974.459-9.523 7.13-8.542 0-7.058-.002-1.184-.002-6.074Zm20.876-5.104c.53.098 1.097.168 1.698.203 0 8.64.005 0 .005 7.177-.732.043-6.416-.368-9.953-3.522l-.01 13.97c.087 6.326-3.435 12.53-10.028 13.78-1.847.35-3.51.39-6.302-.22-3.143-.94-5.464-2.61-7.052-4.668 1.414 1.229 3.19 2.223 5.356 2.872 2.789.608 4.453.57 6.3.219 6.593-1.25 10.114-7.454 10.029-13.778l.009-13.973c3.537 3.155 9.22 3.568 9.955 3.522 0-6.664-.007.311-.007-5.582ZM30.909 1.797v.036c0 .377.068 3.73 2.092 6.557-2.44-1.952-3.31-4.772-3.62-6.593h1.528Z",
    svgColor: "#FF004F"
  }));
});
TikTokColor.displayName = 'TikTokColor';
TikTokColor.defaultProps = {
  'aria-label': 'TikTokColor'
};
export default TikTokColor;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Logo/TikTokColor.js
// module id = 2961
// module chunks = 11